import { MINIMAL_SEARCH_QUERY_LENGTH } from 'config/constants';
import { normalizeSearchValue } from 'helpers/parsing/normalizeSearchValue';
import { StoreLocatorStoreType, StoreLocatorStoreTypeGroups, StoreServiceFiltersType } from 'types/store';

export const filterStoreGroups = (
    stores: StoreLocatorStoreTypeGroups,
    searchValue: string,
    selectedRegion: string,
    selectedDistrict: string,
    serviceFilters: StoreServiceFiltersType,
): StoreLocatorStoreTypeGroups => {
    const trimmedSearchValue = searchValue.trim();
    const normalizedSearchValue =
        trimmedSearchValue.length >= MINIMAL_SEARCH_QUERY_LENGTH ? normalizeSearchValue(trimmedSearchValue) : null;
    const normalizedSearchValueWithoutWhitespace = normalizedSearchValue?.replace(/\s/g, '') ?? null;
    const filterStores = (storesToFilter: StoreLocatorStoreType[]) =>
        storesToFilter.filter(
            (store) =>
                (selectedRegion === '' || store.region === selectedRegion) &&
                (selectedDistrict === '' || store.district === selectedDistrict) &&
                (!serviceFilters.hasLoyaltyProgram || store.hasLoyaltyProgram) &&
                (!serviceFilters.isPickupPoint || store.isPickupPoint) &&
                (!serviceFilters.acceptGiftCoupon || store.acceptGiftCoupon) &&
                (normalizedSearchValue === null ||
                    store.normalizedSearchText.includes(normalizedSearchValue) ||
                    (normalizedSearchValueWithoutWhitespace !== null &&
                        store.normalizedSearchText.includes(normalizedSearchValueWithoutWhitespace))),
        );

    return {
        tescoma: filterStores(stores.tescoma),
        partner: filterStores(stores.partner),
    };
};
